import React from 'react';

import { VisibilityContext } from 'react-horizontal-scrolling-menu';

// eslint-disable-next-line react/prop-types
export function Card({ product }) {
  React.useContext(VisibilityContext);

  return (
    <div
      role="button"
      style={{
        display: 'inline-block',
        margin: '0 10px',
        userSelect: 'none',
      }}
      tabIndex={0}
      className="card"
    >
      {product}
    </div>
  );
}
